import React from 'react';
import { CTAButton } from './CTAButton';
export function StickyFooter() {
  return <div className="fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-sm shadow-lg border-t border-gray-200 py-3 z-50" data-id="element-138">
      <div className="container mx-auto px-4 md:px-8 flex justify-center" data-id="element-139">
        <CTAButton data-id="element-140" />
      </div>
    </div>;
}